<template>
    <blog-list :is-author-page="isAuthorPage" :is-topic-page="isTopicPage" :featured-blog-id="featuredBlogId" :topic-tag-id="topicTagId" :topic-tag-name="topicTagName"></blog-list>
</template>

<script>
    import BlogList from '@/components/BlogSearch/blog-list'

    export default {
        components: {
            BlogList
        },
        props: {
            featuredBlogId: {
                default: 0,
                type: Number
            },
            isAuthorPage: {
                default: false,
                type: Boolean
            },
            isTopicPage: {
                default: false,
                type: Boolean
            },
            topicTagId: {
                default: 0,
                type: Number
            },
            topicTagName: {
                default: null,
                type: String
            }
        }
    }
</script>